module.exports = __webpack_public_path__ + "img/text_decoration_underline.4725a735.svg";